import { render } from "./Subjects.vue?vue&type=template&id=37b4a2d2&scoped=true"
import script from "./Subjects.vue?vue&type=script&lang=js"
export * from "./Subjects.vue?vue&type=script&lang=js"

import "./Subjects.vue?vue&type=style&index=0&id=37b4a2d2&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b4a2d2"]])

export default __exports__